import type { FaireProductEntity } from "../../entity_types/product";

export const p_xu72t72q67: FaireProductEntity = {
  token: "p_xu72t72q67",
  type: "product",
  name: "Navy Bow Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/3fd0dd5ff31cc6effe36ba1c5c766d581543187a8150b344c14f5fb398f868ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/055259754e9eba13565809d539dd0074dbb0538cf3f82e82c9048ba917b392b8.jpeg",
    "https://cdn.faire.com/fastly/ed4ce3d5d96932aef7c2be96fd70b0525e397180e03cac85b7e142f0c2b0fc54.jpeg",
    "https://cdn.faire.com/fastly/a1ab4672203c17bf6b213c76ee368eef209f82dafa37426b94ef5ece54bc1905.webp"
  ],
  priceDollars: 8,
  description: "A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be \"well-edited\" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:07.197Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
